import { useQuery } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { fetchBatchProtocol } from '../api/importService';
/** How often an open detail re-reads a protocol whose stages are still running. */
export var PROTOCOL_POLL_MS = 5000;
/**
 * True while some stage can still change: running, or not reached yet by an import
 * that recorded the rest. An import from before the protocol has nothing pending.
 */
export var isProtocolOpen = function (protocol) { return !!protocol
    && protocol.recorded
    && protocol.phases.some(function (p) { return p.status === 'RUNNING' || p.status === 'PENDING'; }); };
/**
 * CZNA-1344 — the stage protocol of one import. Post-import stages finish long after
 * the batch closes (revalidation runs for minutes), so an open detail keeps polling
 * until no stage is running and stops by itself once they are all settled.
 */
var useImportBatchProtocol = function (batchId) {
    var ky = useOkapiKy();
    return useQuery(['czna-import-batch-protocol', batchId], function () { return fetchBatchProtocol(ky, batchId); }, {
        enabled: !!batchId,
        refetchInterval: function (data) { return (isProtocolOpen(data) ? PROTOCOL_POLL_MS : false); },
    });
};
export default useImportBatchProtocol;
